// @auctogon/core/inventory — canonical inventory-media types + pure helpers.
// Client-safe (no `server-only`); consumed by admin-web, bidder-web, and
// admin-catalog. See ./media.ts for the shape + rationale (BL-767).
export * from './media';
// BL-1476: the document sibling of ./media — same precedence rule, applied to
// the `documents` JSONB columns. Pure and client-safe, like ./media: the URL
// builder is injected, never imported, so this barrel stays free of
// `server-only` (`sharing.md` § 3 root-barrel hygiene).
export * from './external-documents';
// BL-2442: the resizer URL for list thumbnails and the offline cache. Pure, like ./media.
export * from './resized-image';
